import React from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";

const siteUrl = "";

function SEO({ title, description, image, keywords }) {
  const seo = {
    title,
    description,
    image: `${siteUrl}${image}`,
    url: "",
    keywords
  };

  return (
    <>
      <Helmet title={seo.title}>
        <meta name="description" content={seo.description} />
        <meta name="image" content={seo.image} />
        <meta name="keywords" content={seo.keywords} />
        {seo.url && <meta property="og:url" content={seo.url} />}
        {seo.title && <meta property="og:title" content={seo.title} />}
        {seo.description && (
          <meta property="og:description" content={seo.description} />
        )}
        {seo.image && <meta property="og:image" content={seo.image} />}
        <meta name="twitter:card" content="summary_large_image" />
        {seo.title && <meta name="twitter:title" content={seo.title} />}
        {seo.description && (
          <meta name="twitter:description" content={seo.description} />
        )}
        {seo.image && <meta name="twitter:image" content={seo.image} />}
      </Helmet>
    </>
  );
}

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string
};

SEO.defaultProps = {
  title: null,
  description: null,
  image: "https://www.feelcove.com/img/share.png"
};

export default SEO;
